var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open
    ? _c(
        "section",
        {
          staticClass: "ns-popup-section-wrapper",
          on: { click: _vm.closeHandler },
        },
        [
          _c("div", { staticClass: "ns-popup-container" }, [
            _c(
              "div",
              {
                staticClass: "ns-popup-content-container",
                style: _vm.containerStyles,
              },
              [
                !_vm.hideCloseButton
                  ? _c(
                      "div",
                      {
                        staticClass: "ns-popup-close-button",
                        on: {
                          click: function ($event) {
                            _vm.open = false
                          },
                        },
                      },
                      [_c("NsIcon", { attrs: { "icon-name": "icon-close" } })],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "header",
                  { staticClass: "ns-popup-header" },
                  [_vm._t("header")],
                  2
                ),
                _vm._v(" "),
                _vm.text
                  ? _c("p", { staticClass: "ns-popup-text" }, [
                      _vm._v(_vm._s(_vm.text)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("default"),
                _vm._v(" "),
                _c(
                  "footer",
                  { staticClass: "ns-popup-footer" },
                  [_vm._t("footer")],
                  2
                ),
              ],
              2
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }